import { useMemo } from 'react';
import { Tag } from 'antd';
import { 
  FaCrown, 
  FaUserShield, 
  FaShieldAlt, 
  FaUserMd, 
  FaUsers,
  FaFlask,
  FaHeart,
  FaPhone,
  FaDollarSign,
  FaUser,
  FaBullhorn,
} from 'react-icons/fa';

export const useUserTypeRender = () => {
  return useMemo(() => {
    return (type: string) => {
      const typeConfigs: {
        [key: string]: { color: string; icon: React.ReactNode; text: string };
      } = {
        MASTER_ADMIN: { color: 'gold', icon: <FaCrown />, text: 'Master Admin' },
        ADMIN: { color: 'purple', icon: <FaUserShield />, text: 'Admin' },
        SUB_ADMIN: { color: 'geekblue', icon: <FaShieldAlt />, text: 'Sub Admin' },
        DOCTOR: { color: 'blue', icon: <FaUserMd />, text: 'Doctor' },
        MANAGER: { color: 'green', icon: <FaUsers />, text: 'Manager' },
        THERAPIST: { color: 'orange', icon: <FaFlask />, text: 'Therapist' },
        COUNSELLOR: { color: 'magenta', icon: <FaHeart />, text: 'Counsellor' },
        RECEPTIONIST: { color: 'cyan', icon: <FaPhone />, text: 'Receptionist' },
        ACCOUNTANT: { color: 'lime', icon: <FaDollarSign />, text: 'Accountant' },
        MARKETING: { color: 'volcano', icon: <FaBullhorn />, text: 'Marketing' },
      };

      const config = typeConfigs[type] || { color: 'default', icon: <FaUser />, text: type };
      
      return (
        <Tag 
          color={config.color}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            fontWeight: 500,
            padding: '4px 8px',
            borderRadius: '6px',
            lineHeight: '1.2',
          }}
        >
          <span style={{ display: 'flex', alignItems: 'center' }}>
            {config.icon}
          </span>
          <span>{config.text}</span>
        </Tag>
      );
    };
  }, []);
};
